<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';
    import constants from './../../constants.js';

    import SourceSet from './SourceSet.vue';

    export default {
        components: { SourceSet },
        mixins: [mixin],
        props: {
            item: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                constants: constants,
            };
        },
    }
</script>

<template>
    <div class="column is-one-third-desktop">
        <a :href="item.detailUrl"
           class="card card--small is-block is-clipped has-border">
            <div v-if="item.image && item.image.length"
                 class="card-image is-clipped">
                <source-set :image-sets="item.image" />
            </div>
            <div v-if="item.title"
                 class="card-content has-background-transparent">
                <h3 class="title is-5">
                    {{ item.title }}
                </h3>
            </div>
        </a>
    </div>
</template>
